import templateUrl from 'emun.auth/users/user-calendar-token.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import ServiceBus from 'servicestack/service-bus'
import User from 'emun.auth/users/user.model'
import $session from 'servicestack/session'

class controller {
    constructor() {
        const $ctrl = this;
		basicController($ctrl)
		$ctrl.bus = new ServiceBus();
		var queryString = window.location.search.slice(1);
		var vars = queryString.split("&");
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			if (pair[0] == "code") {
				$ctrl.code = pair[1];
			} else if (pair[0] == "state") {
				$ctrl.username = pair[1];
			}
		}
		if ($ctrl.code && $ctrl.username) {
			$ctrl.bus.send('GetToken.json', { username: $ctrl.username, code: $ctrl.code }).then(function (response) {
				$ctrl.token = response.data.meta["cronofyToken"];
			});
		}
    }

}

let UserAuthToken = {
    bindings: {
        username: '@',
        code: '@'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default UserAuthToken;
